import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgExternalIp = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-external-ip';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.36 2.281a8.4 8.4 0 0 0-3.22.879c-2.805 1.379-4.618 4.072-4.867 7.23-.117 1.489.203 3.102.89 4.486.194.391.319.59.444.708.369.35 7.357 6.376 7.393 6.376s7.024-6.026 7.393-6.376c.372-.352.967-1.79 1.184-2.864.628-3.098-.517-6.386-2.923-8.391-1.792-1.493-3.976-2.204-6.294-2.048m1.588 1.54a7.24 7.24 0 0 1 6.05 5.308c.186.701.255 1.334.229 2.111-.037 1.088-.231 1.902-.683 2.864l-.19.403-3.161 2.736C13.455 18.748 12.018 19.98 12 19.98s-1.454-1.231-3.193-2.736l-3.16-2.735-.199-.425c-.45-.955-.638-1.75-.675-2.844-.084-2.53 1.094-4.841 3.183-6.246a7.2 7.2 0 0 1 4.992-1.173M8.811 7.278a.88.88 0 0 0-.481.374c-.065.119-.071.379-.082 3.508-.009 2.367.001 3.425.032 3.531a1 1 0 0 0 .171.296.714.714 0 0 0 1.098 0 1 1 0 0 0 .171-.296c.031-.106.041-1.164.032-3.531-.012-3.323-.013-3.382-.094-3.519a.81.81 0 0 0-.847-.363m3-.002a.9.9 0 0 0-.481.376c-.065.119-.071.379-.082 3.508-.009 2.367.001 3.425.032 3.531a1 1 0 0 0 .171.296c.367.418.992.313 1.233-.207.066-.143.074-.273.075-1.21l.001-1.05.55-.001c.636 0 .934-.058 1.354-.259.524-.253.878-.659 1.084-1.244.106-.304.11-.347.11-1.096.001-.617-.014-.834-.069-1.04-.215-.797-.728-1.327-1.489-1.54-.189-.053-.464-.07-1.3-.082-.583-.008-1.118 0-1.189.018m2.216 1.562c.274.124.31.235.325.982.012.603.007.651-.08.82a.56.56 0 0 1-.292.28c-.175.088-.263.102-.71.114l-.51.014V8.76l.55.001c.454.001.579.014.717.077"
    })
  }));
});
export default SvgExternalIp;